import React from "react";
import { GoogleReCaptchaProvider as GoogleReCaptchaReactProvider } from "react-google-recaptcha-v3";
import { getCookie } from "services/cookies";
import { COOKIES } from "constants/cookies";

export const GoogleReCaptchaProvider = ({ children }) => {
  const captchaSiteKey =
    getCookie(COOKIES.RECAPTCHA_SITE_KEY) ||
    getCookie(COOKIES._GRECAPTCHA) ||
    process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
  return (
    <GoogleReCaptchaReactProvider reCaptchaKey={captchaSiteKey}>
      {children}
    </GoogleReCaptchaReactProvider>
  );
};
